import type { ButtonBaseProps } from '@mui/material';
import { ButtonBase, Typography } from '@mui/material';

/**
 * render a link that has no href-target but onClick doings.
 * Ripple is disabled and link like typography is added.
 * @param props
 * @returns JSX.Element
 */
export const LinkButton = (props: ButtonBaseProps) => (
  <ButtonBase {...props} disableRipple>
    <Typography variant="body2" sx={{ textDecoration: 'underline' }} component="span">
      {{ ...props }.children}
    </Typography>
  </ButtonBase>
);
